<template>
  <section>
    <template v-if="contractId > 4856">
      <aRow>
        <aCol
          class="collapse-card"
          v-for="{ id } in customPaymentRows"
          :key="id"
          :span="24"
        >
          <div class="head" @click="onClickOpenCollapse(id)">
            <aRow :gutter="20">
              <aCol class="id cprimary" :span="1">
                <span class="ico">
                  <aIcon type="dollar" />
                  <span class="num">{{ id }}</span>
                </span>
              </aCol>

              <aCol class="id-name" :span="11">
                {{
                  tempContract[
                    `payment_methods_custom_payment_name_${id}${keySuffix}`
                  ] ?? "PG. PERSONALIZADO"
                }}
              </aCol>

              <aCol class="value" :span="9">
                <aTag :color="'blue'">
                  {{
                    tempContract[
                      `payment_methods_custom_payment_total_value_${id}${keySuffix}`
                    ] | formatPricePtBrComma
                  }}
                </aTag>
              </aCol>

              <aCol class="a-right" :span="3">
                <aButton
                  class="ml-5"
                  v-if="id > 1 && customPaymentRows.length === id"
                  size="small"
                  type="danger"
                  shape="circle"
                  icon="delete"
                  @click="removeRow(id - 1)"
                  ghost
                >
                </aButton>
              </aCol>
            </aRow>
          </div>

          <div class="content" v-if="openCollapse === id">
            <CustomPaymentCollapse
              :form="form"
              :customPaymentId="id"
              :tempContract="tempContract"
              :keyPrefix="keyPrefix"
              :keySuffix="keySuffix"
              @updateCustomPaymentValue="updateCustomPaymentValue"
            />
          </div>
        </aCol>
      </aRow>

      <div class="a-center mb-40 mt-20">
        <aButton
          type="primary"
          @click="addNewRow(customPaymentRows.length)"
          ghost
        >
          Adicionar pagamento personalizado
        </aButton>
        <aFormItem class="none">
          <aInput v-decorator="[`custom_payment_rows${keySuffix}`]" />
          <aInput
            v-decorator="[
              `payment_methods_custom_payment_total_value${keySuffix}`,
            ]"
          />
        </aFormItem>
      </div>
    </template>
  </section>
</template>

<script>
import { parse } from "vue-currency-input";
import formatThings from "@/mixins/general/formatThings.js";
import CustomPaymentCollapse from "@/components/contracts/collapses/CustomPaymentCollapse.vue";

export default {
  name: "CustomPaymentTabModal",
  props: {
    tempContract: Object,
    form: Object,
    keyPrefix: String,
    keySuffix: String,
  },
  components: {
    CustomPaymentCollapse,
  },
  mixins: [formatThings],
  data() {
    return {
      openCollapse: "",
      customPaymentRows: [],
      contractId: parseInt(this.tempContract.id),
    };
  },
  mounted() {
    if (
      this.tempContract[`custom_payment_rows${this.keySuffix}`] !== undefined
    ) {
      this.customPaymentRows = JSON.parse(
        this.tempContract[`custom_payment_rows${this.keySuffix}`]
      );

      this.form.setFieldsValue({
        [`custom_payment_rows${this.keySuffix}`]: JSON.stringify(
          this.customPaymentRows
        ),
      });
    }

    this.updateCustomPaymentValue();
  },
  methods: {
    onClickOpenCollapse(id) {
      if (id == this.openCollapse) {
        this.openCollapse = 0;
      } else {
        this.openCollapse = id;
      }
    },
    addNewRow(id) {
      this.customPaymentRows.push({
        id: id + 1,
      });

      this.tempContract[`custom_payment_rows${this.keySuffix}`] =
        JSON.stringify(this.customPaymentRows);

      this.form.setFieldsValue({
        [`custom_payment_rows${this.keySuffix}`]: JSON.stringify(
          this.customPaymentRows
        ),
      });

      this.updateCustomPaymentValue();
    },
    removeRow(index) {
      for (var i in this.customPaymentRows) {
        if (i == index) {
          this.customPaymentRows.splice(i, 1);
          break;
        }
      }

      this.tempContract[`custom_payment_rows${this.keySuffix}`] =
        JSON.stringify(this.customPaymentRows);

      this.form.setFieldsValue({
        [`custom_payment_rows${this.keySuffix}`]: JSON.stringify(
          this.customPaymentRows
        ),
      });

      this.updateCustomPaymentValue();
    },
    updateCustomPaymentValue() {
      let theTotal = 0;
      this.customPaymentRows.forEach((customPayment) => {
        theTotal += parse(
          this.tempContract[
            `payment_methods_custom_payment_total_value_${customPayment.id}${this.keySuffix}`
          ]
        );
      });

      this.form.setFieldsValue({
        [`payment_methods_custom_payment_total_value${this.keySuffix}`]:
          `${theTotal}`.replace(".", ","),
      });

      this.$emit("updateTotalValue");
    },
  },
};
</script>

<style lang="sass" scoped>
.collapse-card
  .content
    padding: 30px 20px 20px
    border: 1px solid #ccc
    margin-top: -14px
    border-radius: 0 0 6px 6px
    margin-bottom: 11px
    background: #fff
  .head
    cursor: pointer
    clear: both
    padding:  20px
    background: #fff
    border: 1px solid #ccc
    margin-bottom: 10px
    border-radius: 6px
    .id
      color: #474747
      font-weight: 600
      .ico
        position: relative
        font-size: 14px
      .num
        position: absolute
        right: -13px
        top: 0
        font-size: 11px
        color: #333
    .id-name
      padding-left: 20px !important
      color: #42413f
      font-weight: 500
      text-transform: uppercase
    .value
      font-size: 10px
      color: #42413f
      font-weight: 500
      text-transform: uppercase
</style>